import { withExploreGalleryProps } from 'viewModel/gallery/withExploreGalleryProps';
import ExploreGallery from 'components/Community/ExploreGallery/ExploreGallery';

export default withExploreGalleryProps(ExploreGallery);
